import { Link } from "react-router-dom";
import css from "./Offerings.module.css";

const Service = ({ service }) => {
  return (
    <Link
      className={`${css.service_container} ${`service_[${service.service.toLowerCase()}]`}`}
      to={service.link}
    >
      <p className={css.service}>{service.service}</p>
      <img className={css.img} src={service.img} alt={service.alt} />
    </Link>
  );
};

export default Service;
